"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftRailHeader = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var LeftRailButton_1 = require("../../containers/LeftRailButton/LeftRailButton");
require("./styles.less");
var onBackClick = function () {
    window.history.back();
};
var IS_RETURNABLE_HASH = 'returnable';
function LeftRailHeader(props) {
    var isReturnable = window.location.hash.includes(IS_RETURNABLE_HASH);
    var backToList;
    if (isReturnable && window.history.length === 1) {
        isReturnable = false;
        window.location.hash = '';
    }
    if (!isReturnable || document.referrer === '') {
        backToList = (React.createElement(LeftRailButton_1.LeftRailButton, { url: props.homepageUrl, title: 'Back to list' }));
    }
    else {
        backToList = (React.createElement(LeftRailButton_1.LeftRailButton, { onClick: onBackClick, title: 'Back to list' }));
    }
    return (React.createElement("header", { className: 'm-left-rail-header' },
        React.createElement("a", { className: 'm-left-rail-header__link', href: props.homepageUrl, target: '_self' }, "Green Section Record"),
        React.createElement("span", { className: 'm-left-rail-header__date' }, props.date),
        React.createElement("div", { className: 'm-left-rail-header__column' }, renderIssues(props.issues)),
        React.createElement("div", { className: 'm-left-rail-header__buttons' },
            backToList,
            React.createElement(LeftRailButton_1.LeftRailButton, { url: props.subscribeLink, title: 'Subscribe', colored: true }))));
}
exports.LeftRailHeader = LeftRailHeader;
function renderIssues(issues) {
    if (!(issues && issues.length)) {
        return;
    }
    return issues.map(function (value, index) {
        return React.createElement("span", { className: 'm-left-rail-header__tag', key: index }, value);
    });
}
